import { Box, FormControlLabel, RadioGroup, Stack } from "@mui/material";
import Radio from "@mui/material/Radio";
import { useState, useEffect } from "react";
import axios from "axios";
import regenerateToken from "./regenerateTokens";

import ProfileContent from "./contentManagement/ProfileContent";
import ParameterContent from "./contentManagement/ParameterContent";
import VersionManagement from "./contentManagement/VersionManagement";
import { markNextCallsAsIgnored } from "../../lib/activityLogQueryParam";

const ContentManagement = () => {
  const [contentType, setContentType] = useState("profilecontent");
  const [editVersion, setEditVersion] = useState("");
  const [reportType, setReportType] = useState("dynamic");
  const [loading, setLoading] = useState(true);

  const getStateConfiguration = async () => {
    const idToken = localStorage.getItem("idTokenBilling");

    const existingStateConfigBody = {
      headers: {
        authorization: idToken,
      },
      method: "GET",
      url: "https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/config/state",
      validateStatus: function (status) {
        return status >= 200 && status <= 401;
      },
    };
    const existingStateConfigResponse = await axios(existingStateConfigBody);
    return existingStateConfigResponse;
  };

  // Fetch Smart Report configuration to get selected report type
  useEffect(() => {
    markNextCallsAsIgnored(5000);
    (async function () {
      try {
        const response = await getStateConfiguration();
        
        if (response.status === 401) {
          await regenerateToken();
          const response = await getStateConfiguration();
          if (response.data.isSuccess) {
            const stateData = response.data.data.stateData;
            const currentReportType = stateData.reportType || "dynamic";
            setReportType(currentReportType);
            
            // If report type is compact and current contentType is parametercontent, switch to profilecontent
            if (currentReportType === "compact" && contentType === "parametercontent") {
              setContentType("profilecontent");
            }
          }
        } else {
          if (response.data.isSuccess) {
            const stateData = response.data.data.stateData;
            const currentReportType = stateData.reportType || "dynamic";
            setReportType(currentReportType);
            
            // If report type is compact and current contentType is parametercontent, switch to profilecontent
            if (currentReportType === "compact" && contentType === "parametercontent") {
              setContentType("profilecontent");
            }
          }
        }
      } catch (error) {
        console.log("Error fetching Smart Report config:", error.message);
        setReportType("dynamic");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const renderSpecificPContentType = () => {
    switch (contentType) {
      case "profilecontent":
        return (
          <ProfileContent
            version={editVersion}
            setEditVersion={setEditVersion}
          />
        );
      case "parametercontent":
        return (
          <ParameterContent
            version={editVersion}
            setEditVersion={setEditVersion}
          />
        );
      case "versionmanagement":
        return (
          <VersionManagement
            version={editVersion}
            setEditVersion={setEditVersion}
            setContentType={setContentType}
          />
        );
      default:
        return <ProfileContent />;
    }
  };
  if (loading) {
    return (
      <Stack>
        <Box pl={2}>
          <div>Loading...</div>
        </Box>
      </Stack>
    );
  }

  return (
    <Stack>
      <Box pl={2}>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          value={contentType}
          onChange={(e) => {
            setContentType(e.target.value);
            markNextCallsAsIgnored(5000);
          }}
        >
          <FormControlLabel
            value="versionmanagement"
            control={<Radio />}
            label="Version Management"
          />
          <FormControlLabel
            value="profilecontent"
            control={<Radio />}
            label="Profile Content"
          />
          {reportType !== "compact" && (
            <FormControlLabel
              value="parametercontent"
              control={<Radio />}
              label="Parameter Content"
            />
          )}
        </RadioGroup>
      </Box>
      {renderSpecificPContentType()}
    </Stack>
  );
};

export default ContentManagement;
